<template>
  <v-container fluid>
    <!-- Info messages to show -->
    <v-messages />
    <!-- The bubble to select the feature -->
    <v-feature-bubble />
    <!-- List of products -->
    <v-products />
    <!-- Button to load more products -->
    <v-pagination />
  </v-container>
</template>

<script>
import VFeatureBubble from "./FeatureBubble";
import VProducts from "./Products";
import VMessages from "./Messages";
import VPagination from "./Pagination.vue";

export default {
  components: {
    VFeatureBubble,
    VProducts,
    VMessages,
    VPagination
  }
};
</script>
